import { render, staticRenderFns } from "./VerticalTabs.vue?vue&type=template&id=79ba8f36&scoped=true"
import script from "./VerticalTabs.vue?vue&type=script&lang=js"
export * from "./VerticalTabs.vue?vue&type=script&lang=js"
import style0 from "./VerticalTabs.vue?vue&type=style&index=0&id=79ba8f36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ba8f36",
  null
  
)

export default component.exports